<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="mb-3 text-sm text-gray-700">
      One row per master rule from Utilities &gt; AI Guidelines. To change a rule for this program only, type in
      Program Override. The AI reads the master, then the overrides above, then this one; the narrowest wins where
      they differ.
    </div>
    <div class="grow">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="grid.rows"></prox-ag-grid>
    </div>
  </div>
</div>
